/* global axios */

import ApiClient from './ApiClient';

class CampaignsAPI extends ApiClient {
  constructor() {
    super('campaigns', { accountScoped: true });
  }

  analyticsMetrics(id) {
    return axios.get(`${this.url}/${id}/analytics/metrics`);
  }

  analyticsContacts(id, { status, page } = {}) {
    return axios.get(`${this.url}/${id}/analytics/contacts`, {
      params: { status, page },
    });
  }

  getAudienceEstimate({ labelIds = [], conversationLabelIds = [] } = {}) {
    return axios.get(`${this.url}/audience_estimate`, {
      params: {
        label_ids: labelIds,
        conversation_label_ids: conversationLabelIds,
      },
    });
  }
}

export default new CampaignsAPI();
